import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import { Icon } from '@deity-io/portal-ui';
import { CACHE_FIRST, toLocalDateString } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useGetPackageLazyQuery } from 'services/graphql/generated/hooks';
import { validate as validateUuid } from 'uuid';
import type { IClusterStatePackage } from '../IRuntimeState';
import { PackageVersionBadge } from './PackageVersionBadge';

type PackageItemProps = {
  packageKey?: string;

  clusterPackage: IClusterStatePackage;
};
export const PackageItem: FC<PackageItemProps> = ({ packageKey, clusterPackage }) => {
  const [getPackage, { loading: packageLoading, data: packageData }] = useGetPackageLazyQuery(CACHE_FIRST);

  useEffect(() => {
    if (packageKey && validateUuid(packageKey)) {
      getPackage({
        variables: {
          uuid: packageKey
        }
      });
    }
  }, [packageKey]);

  return (
    <>
      <H4 fontSize="lg" color="primaryText">
        {clusterPackage.accountUuid === '1' ? 'system' : `...-${clusterPackage.accountUuid.split('-').pop()}`}
      </H4>
      <Box>
        <H4 fontSize="lg" color="primaryText" fontWeight="bold">
          {`${packageData?.getPackage.name || packageKey}`}
        </H4>
      </Box>
      <H4 style={{ justifySelf: 'center' }}>
        {mapRecordToArray(clusterPackage.versions, (v, key) => (
          <PackageVersionBadge packageVersionKey={key} />
        ))}
      </H4>
      <FlexLayout alignItems="center" justifyContent="end" css={{ width: '100%' }}>
        <H4 fontSize="lg" color="primaryText" mr="xs">
          {clusterPackage.instances.length} x
        </H4>
        <Icon icon="cloud" />
      </FlexLayout>
      <FlexLayout alignItems="end" justifyContent="end" css={{ width: '100%' }}>
        <H4 fontSize="lg" color="primaryText">
          {clusterPackage.count}
        </H4>
      </FlexLayout>
      <H4 fontSize="lg" color="primaryText">
        {clusterPackage.last ? toLocalDateString(clusterPackage.last || '') : ''}
      </H4>
    </>
  );
};
